// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"0da30c4868f80da13552","678":"3d954a157e33085d4fd8"}[chunkId] + ".js";
};